
    import '/home/ec2-user/Youlify-Design/components/spin/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["spin-demo-basic","spin-demo-size","spin-demo-nested","spin-demo-tip","spin-demo-delayanddebounce","spin-demo-custom-indicator","spin-demo-percent","spin-demo-fullscreen"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/spin/index.zh-CN.md?type=demo')
};